import React, {useState, useEffect} from "react";
import {crud} from "../crudRequests";
import {
  Box,
  Flex,
  FormControl,
  FormLabel,
  Switch,
  Text,
} from "@chakra-ui/react";

export default function TFA({dashState}) {
  const {patient, relationship} = dashState;
  const [enabled, setEnabled] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    crud(dashState, [
      {
        db: dashState.db,
        collection: "security",
        parameters: [
          {
            userId:
              dashState?.userType === "patient"
                ? patient?.pid
                : relationship?.rid,
          },
        ],
        method: "findOne",
      },
    ])
      .then((res) => setEnabled(!!res?.data?.[0]?.tfa))
      .catch(() => {});
  }, []);

  function toggle() {
    if (saving) return;
    setSaving(true);
    const next = !enabled;
    // Optimistically update UI so helper text hides/shows immediately
    setEnabled(next);
    crud(dashState, [
      {
        db: dashState.db,
        collection: "security",
        parameters: [
          {
            userId:
              dashState?.userType === "patient"
                ? patient?.pid
                : relationship?.rid,
          },
          {$set: {tfa: next}},
        ],
        method: "updateOne",
      },
    ])
      .catch(() => setEnabled(!next))
      .finally(() => setSaving(false));
  }

  return (
    <Box>
      <Flex align="center" justify="space-between">
        <Box mr={4}>
          <FormLabel
            htmlFor="tfa-toggle"
            mb={0}
            fontSize="sm"
            fontWeight="medium"
          >
            Enable 2FA
          </FormLabel>
          <Text fontSize="xs" color="gray.500" mt={1}>
            {enabled
              ? "Active — codes required on new devices"
              : "Off — only password required"}
          </Text>
        </Box>
        <Switch
          id="tfa-toggle"
          isChecked={enabled}
          isDisabled={saving}
          colorScheme="purple"
          onChange={toggle}
          size="md"
        />
      </Flex>
    </Box>
  );
}
